import type {
  AvatarUrlRequest,
  CheckUserStatusRequest,
  CheckUserStatusResponse,
  SendMagicLinkRequest,
  SendMagicLinkResponse,
} from 'src/api/ProactApiClient';
import {userApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const userApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    checkUserStatus: builder.query<
      CheckUserStatusResponse,
      CheckUserStatusRequest
    >({
      queryFn: clientQuery(request => userApiClient.checkUserStatus(request)),
      providesTags: ['Users'],
    }),
    sendMagicLink: builder.mutation<
      SendMagicLinkResponse,
      SendMagicLinkRequest
    >({
      queryFn: clientQuery(request => userApiClient.sendMagicLink(request)),
    }),
    updateAvatarUrl: builder.mutation<boolean, AvatarUrlRequest>({
      queryFn: clientQuery(request => userApiClient.updateAvatarUrl(request)),
      invalidatesTags: ['Users'],
    }),
    enableOwnMfa: builder.mutation<boolean, void>({
      queryFn: clientQuery(() => userApiClient.enableMfa()),
    }),
    disableOwnMfa: builder.mutation<boolean, void>({
      queryFn: clientQuery(() => userApiClient.disableMfa()),
    }),
  }),
});

export const {
  useCheckUserStatusQuery,
  useLazyCheckUserStatusQuery,
  useSendMagicLinkMutation,
  useUpdateAvatarUrlMutation,
  useEnableOwnMfaMutation,
  useDisableOwnMfaMutation,
} = userApi;
